/// <reference path="./@types/global.d.ts" />

// No exports from root index
// Users need to import directly from submodules
// Examples: import { ... } from 'dinocollab-core/form'
//           import { ... } from 'dinocollab-core/table'

// Only export a message to help users understand how to use the library
export const LIBRARY_INFO = {
  name: 'dinocollab-core',
  version: '2.0.0',
  usage: 'Import from submodules for optimized bundle size. Example: import { ... } from "dinocollab-core/form"'
}
